<template>
  <DataListStateful
    title="Артикулы"
    resource="articles"
    store="articles"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", dataPath: "Id", sortable: false },
        {
          title: "Наименование",
          name: "title",
          dataPath: "Title",
          sortable: true,
        },
        {
          title: "Модель",
          name: "model",
          dataPath: "Model.Title",
          sortable: true,
        },
        {
          title: "ТМ",
          name: "trademark",
          dataPath: "Trademark.Title",
          sortable: true,
        },
        {
          title: "Производитель",
          name: "manufacturer",
          dataPath: "Manufacturer.Title",
          sortable: true,
          width: "100",
          maxLength: 20,
        },
        {
          title: "Категория",
          name: "productCategory",
          dataPath: "ProductCategory.Title",
          sortable: true,
          width: "100",
          maxLength: 20,
        },
        {
          title: "Номеклатура",
          name: "nomenclature",
          dataPath: "Nomenclature.Title",
          sortable: true,
          width: "100",
          maxLength: 20,
        },
        { title: "Вес нетто", name: "weightNetto", sortable: true },
        { title: "Вес брутто", name: "weightBrutto", sortable: true },
        {
          title: "Единица измерения",
          name: "unit",
          dataPath: "Unit.Title",
          sortable: true,
        },
        {
          title: "Материал",
          name: "material",
          sortable: true,
          width: "100",
          maxLength: 20,
        },
        { title: "Размеры", name: "dimensions", sortable: true },
        { title: "Сайт продукта", name: "productSite", sortable: false },
        {
          title: "Страна происхождения",
          name: "country",
          dataPath: "Country.Title",
          sortable: true,
        },
        { title: "Дата создания", name: "date", sortable: false },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        productCategory: {
          title: "Категория",
          type: "reference",
          resource: "product-categories",
        },
        site: {
          title: "Сайт продукта",
          type: "text",
        },
        trademark: {
          title: "ТМ",
          type: "reference",
          resource: "trademarks",
        },
        model: {
          title: "Модель",
          type: "reference",
          resource: "trademark-models",
        },
        manufacturer: {
          title: "Производитель",
          type: "reference",
          resource: "manufacturers",
        },
        nomenclature: {
          title: "Номенклатура",
          type: "reference",
          resource: "nomenclatures",
        },
        weightBrutto: {
          title: "Вес брутто",
          type: "decimal",
        },
        weightNetto: {
          title: "Вес нетто",
          type: "decimal",
        },
        unit: {
          title: "Единица измерения",
          type: "reference",
          resource: "units",
        },
        country: {
          title: "Страна происхождения",
          type: "reference",
          resource: "countries",
        },
        material: {
          title: "Материал",
          type: "text",
        },
        dimensions: {
          title: "Размеры",
          type: "text",
        },
        date: {
          title: "Дата создания",
          type: "date",
        },
      },
    };
  },
};
</script>
